import {
  CreateAssessmentBody,
  IAssessmentResponse,
  IAssessmentsRequest,
  IAssessmentsResponse
} from 'types/assessments';
import request from './index';
import qs from 'qs';
import {
  IAssessmentScoreResponse,
  IPatchAssessmentScoreRequest,
  IPostAssessmentScoreRequest
} from 'types/forms/assessments';
import { serialize } from 'object-to-formdata';
import toErrorWithMessage from 'utilities/getErrorMessage';

export const getAssessments = ({ filters }: IAssessmentsRequest) => {
  const query = qs.stringify(filters, { arrayFormat: 'brackets' });

  return request<IAssessmentsResponse>({
    options: {
      url: `/assessments?${query}`,
      method: 'get'
    }
  });
};

export const postAssessments = (data: { assessment: CreateAssessmentBody }) => {
  return request<IAssessmentResponse>({
    options: {
      url: `/assessments`,
      method: 'post',
      data
    }
  });
};

export const patchAssessments = (
  id: number,
  data: { assessment: CreateAssessmentBody }
) => {
  return request<IAssessmentResponse>({
    options: {
      url: `/assessments/${id}`,
      method: 'patch',
      data
    }
  });
};

export const getAssessment = (id: number) => {
  try {
    return request<IAssessmentResponse>({
      options: {
        url: `/assessments/${id}`,
        method: 'get'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const deleteAssessment = (id: number) => {
  try {
    return request<{}>({
      options: {
        url: `/assessments/${id}`,
        method: 'delete'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const postAssessmentScore = (
  assessmentId: number,
  data: IPostAssessmentScoreRequest
) => {
  return request<IAssessmentScoreResponse>({
    options: {
      url: `/assessments/${assessmentId}/scores`,
      method: 'post',
      data: serialize(data)
    }
  });
};

export const patchAssessmentScore = (
  assessmentId: number,
  id: number,
  data: IPatchAssessmentScoreRequest
) => {
  return request<IAssessmentScoreResponse>({
    options: {
      url: `/assessments/${assessmentId}/scores/${id}`,
      method: 'patch',
      data: serialize(data)
    }
  });
};
